import { RouterParams } from './interfaces/IRouter';

const thankyoupageMiddleware = ({ next, router }: RouterParams) => {
  return next();
};

export { thankyoupageMiddleware };
